var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarColor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.718,
    height: 50,
    viewBox: "0 0 48.718 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar_color",
    transform: "translate(-5 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3972",
    "data-name": "Path 3972",
    d: "M5,44.6V14H53.718V44.6a5.129,5.129,0,0,1-5.128,5.1H10.128A5.129,5.129,0,0,1,5,44.6Z",
    transform: "translate(0 3.297)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3973",
    "data-name": "Path 3973",
    d: "M53.718,11.2V19H5V11.2A5.179,5.179,0,0,1,10.128,6H48.59A5.179,5.179,0,0,1,53.718,11.2Z",
    transform: "translate(0 0.899)",
    fill: "#f44336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3974",
    "data-name": "Path 3974",
    d: "M38.707,7a3.9,3.9,0,1,0,3.815,3.9A3.858,3.858,0,0,0,38.707,7ZM15.815,7a3.9,3.9,0,1,0,3.815,3.9A3.858,3.858,0,0,0,15.815,7Z",
    transform: "translate(2.098 1.199)",
    fill: "#b71c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3975",
    "data-name": "Path 3975",
    d: "M38.384,3a2.577,2.577,0,0,0-2.538,2.6v6.5a2.539,2.539,0,1,0,5.077,0V5.6A2.577,2.577,0,0,0,38.384,3ZM15.538,3A2.577,2.577,0,0,0,13,5.6v6.5a2.539,2.539,0,1,0,5.077,0V5.6A2.577,2.577,0,0,0,15.538,3Z",
    transform: "translate(2.398 0)",
    fill: "#b0bec5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2638",
    "data-name": "Group 2638",
    transform: "translate(15.062 24.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3976",
    "data-name": "Path 3976",
    d: "M13,20h5.2v5.2H13Zm7.8,0H26v5.2H20.8Zm7.8,0h5.2v5.2H28.6Zm7.8,0h5.2v5.2h-5.2ZM13,27.8h5.2V33H13Zm7.8,0H26V33H20.8Zm7.8,0h5.2V33H28.6Zm7.8,0h5.2V33h-5.2ZM13,35.6h5.2v5.2H13Zm7.8,0H26v5.2H20.8Zm7.8,0h5.2v5.2H28.6Zm7.8,0h5.2v5.2h-5.2Z",
    transform: "translate(-13 -20)",
    fill: "#90a4ae"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarColor);
export default __webpack_public_path__ + "static/media/calendar_color.705bcc413b8885ce97981bad3308b23f.svg";
export { ForwardRef as ReactComponent };